// AI Generated Test
import { ChartModel } from '@client/app/blocks/service/charts/base-chart/chart-factory';
import { BaseChart } from '../chart';

export class DoughnutChart extends BaseChart {

    constructor (attributes?: Partial<ChartModel>) {
        super(attributes);
        (this.options as any).cutoutPercentage = 70;
        (this.options as any).centerText = {};
    }

    /**
     * @description Set the cut out percentage of the doughnut, default value is described in the constructor method
     * @param {number} percentage
     */
    setCutOutPercentage (percentage: any): void {
        (this.options as any).cutoutPercentage = percentage;
    }

    /**
     * @description Set the centerText of the doughnut
     * @param {any} percentage
     * @param {any} total
     * @param {any} sub
     */
    setCenterText (percentage: any, total: any, sub: any): void {
        (this.options as any).centerText = {
            percentageLabel: percentage,
            totalLabel: total,
            subLabel: sub,
        };
    }

    /**
     * @description Set the font size of the percentage text
     * @param {any} size
     */
    setPercentageFontSize (size: any): void {
        (this.options as any).centerText = (this.options as any).centerText || {};
        (this.options as any).centerText.percentageFontSize = size;
    }

    /**
     * @description Set the font weight of the percentage text
     * @param {any} size
     */
    setPercentageFontWeight (size: any): void {
        (this.options as any).centerText = (this.options as any).centerText || {};
        (this.options as any).centerText.percentageFontWeight = size;
    }

    /**
     * @description Set the font size of the total text
     * @param {any} size
     */
    setTotalFontSize (size: any): void {
        (this.options as any).centerText = (this.options as any).centerText || {};
        (this.options as any).centerText.totalFontSize = size;
    }

    /**
     * @description Set the font weight of the total text
     * @param {any} size
     */
    setTotalFontWeight (size: any): void {
        (this.options as any).centerText = (this.options as any).centerText || {};
        (this.options as any).centerText.totalFontWeight = size;
    }

    /**
     * @description Set the font size of the sub text
     * @param {any} size
     */
    setSubFontSize (size: any): void {
        (this.options as any).centerText = (this.options as any).centerText || {};
        (this.options as any).centerText.subFontSize = size;
    }

    /**
     * @description Set the font weight of the sub text
     * @param {any} size
     */
    setSubFontWeight (size: any): void {
        (this.options as any).centerText = (this.options as any).centerText || {};
        (this.options as any).centerText.subFontWeight = size;
    }
}
